/**
 * Cuanto tiempo lleva un cliente sin pedir es el dato que justifica esta
 * seccion, asi que se destaca en vez de quedarse como un numero mas de la fila.
 *
 * Los dos umbrales, medidos sobre las 295 filas de produccion (media de 2,48
 * semanas, maximo 26):
 *
 * | Umbral | Significado          | Clientes reales |
 * |--------|----------------------|-----------------|
 * | 4      | Un mes sin pedir     | 61 de 295 (21%) |
 * | 8      | Dos meses sin pedir  | 19 de 295 (6%)  |
 *
 * Estan elegidos para que la marca siga significando algo: con un umbral de
 * una semana se encenderia casi toda la tabla y el operador dejaria de mirarla.
 */
export const SEMANAS_ATENCION = 4
export const SEMANAS_CRITICO = 8

export type NivelSemanas = 'normal' | 'atencion' | 'critico'

interface Nivel {
  /** Palabra que acompana al color. Vacia en `normal`: no hay nada que decir. */
  etiqueta: string
  clase: string
}

/**
 * Cada nivel destacado lleva **color y palabra**, nunca solo color: hay
 * operadores que no distinguen bien los colores, y para ellos un fondo ambar y
 * uno rojo son la misma celda. La palabra no es decoracion, es la mitad del
 * mensaje.
 */
export const NIVELES: Record<NivelSemanas, Nivel> = {
  normal: { etiqueta: '', clase: 'text-tinta-2' },
  atencion: {
    etiqueta: 'Atencion',
    clase: 'bg-atencion-fondo text-atencion-tinta ring-1 ring-atencion-anillo',
  },
  critico: {
    etiqueta: 'Critico',
    clase: 'bg-critico-fondo text-critico-tinta ring-1 ring-critico-anillo',
  },
}

/**
 * El umbral es "esas semanas o mas", no "mas que esas": quien lleva exactamente
 * un mes sin pedir es justo el caso que hay que ver, no el primero que se
 * queda fuera.
 */
export function nivelDeSemanas(semanas: number): NivelSemanas {
  if (semanas >= SEMANAS_CRITICO) return 'critico'
  if (semanas >= SEMANAS_ATENCION) return 'atencion'
  return 'normal'
}
